import React, { Component } from 'react'
import { Query } from 'react-apollo'
import { withRouter } from 'react-router-dom'

import '../styles/ranged-tables.scss'
import messages from '../constants/messages'
import { RANGED_FIELD_QUERY } from '../constants/queries'
import Message from '../views/Message'

import ResponseMiddleware from '../Middleware/ResponseMiddleware'

import Sidebar from '../containers/RangedField/Sidebar'
import Heading from '../views/TypeHeading'
import ShootersTable from '../containers/RangedField/ShootersTable'
import SidebarHOC from '../components/SidebarHOC'

class RangedField extends Component {
  componentDidMount() {
    this.props.onShowSearch(false)
    this.props.onShowNav(false)
  }

  render() {
    const response = new ResponseMiddleware()
    response.setComponent((data) => (
      <div
        className="content-wrapper relative"
        style={{
          paddingTop: data.rangedField.category === '' && '30px',
        }}
      >
        {data.rangedField.category !== '' && <Heading className="ranged-field" {...data.rangedField} />}
        {data.rangedField.category !== '' ? (
          <ShootersTable {...data.rangedField} />
        ) : (
          <Message text={messages.refineSearch} />
        )}
      </div>
    ))

    return (
      <div className="full-page-wrapper full-page-wrapper--is-fluid full-page-wrapper--is-full-width shooters-table">
        <SidebarHOC>
          <Sidebar />
        </SidebarHOC>

        <Query query={RANGED_FIELD_QUERY}>{response.execute}</Query>
      </div>
    )
  }
}

export default withRouter(RangedField)
